import { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken } from "@/lib/api";

const PortalAuthCtx = createContext(null);

export function PortalAuthProvider({ children }) {
  const [me, setMe] = useState(null);   // { person, society, owned_units, occupied_units }
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/portal/me");
      setMe(data);
      return data;
    } catch {
      setMe(false);
      return null;
    }
  };

  useEffect(() => {
    (async () => {
      await refresh();
      setLoading(false);
    })();
  }, []);

  const verify = async (tenant_slug, identifier, otp) => {
    const { data } = await api.post("/portal/otp/verify", { tenant_slug, identifier, otp });
    setAuthToken(data.token);
    await refresh();
    return data.person;
  };

  const requestOtp = async (tenant_slug, identifier) => {
    const { data } = await api.post("/portal/otp/request", { tenant_slug, identifier });
    return data;
  };

  const logout = async () => {
    try { await api.post("/portal/logout"); } catch {/*noop*/}
    setAuthToken(null);
    setMe(false);
  };

  return (
    <PortalAuthCtx.Provider value={{ me, loading, requestOtp, verify, logout, refresh }}>
      {children}
    </PortalAuthCtx.Provider>
  );
}

export const usePortalAuth = () => useContext(PortalAuthCtx);
